<!-- =========================================================================================
    File Name: Register.vue
    Description: Register Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
<div class="h-screen flex w-full bg-img vx-row no-gutter justify-center ">
    <div class="vx-col w-full md:w-3/4 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
        <vx-card class="h-screen md:mt-10  ">
            <div slot="no-body" class="full-page-bg-color ">
                <div class="vx-row no-gutter mb-32 ">

                    <div class="vx-col sm:w-full md:w-full   mx-auto self-center  d-theme-dark-bg ">
                        <div class="px-4 pt-8 register-tabs-container  h-full">
                            <div class="vx-card__title mb-4">
                                <h4 class="mb-4">Demande Compte Fournisseur </h4>
                                <p>Fiche Signalitique Fournisseur</p>
                            </div>
                            <vs-tabs :value="activeTabNum">
                                <vs-tab label="Coordonnées Fournisseurs">
                                    <info :infoFournissseur="infoFournissseur" @updatePage="numPage"></info>
                                </vs-tab>
                                <vs-tab label="Communication" class=" ">
                                    <tab1 :infoFournissseur="infoFournissseur" @updatePage="numPage"></tab1>
                                </vs-tab>
                                <vs-tab label="Facturation & Paiement">
                                    <tab2 :infoFournissseur="infoFournissseur" @updatePage="numPage"></tab2>
                                </vs-tab>
                                <vs-tab label="Achats & Logistique">
                                    <tab3 :infoFournissseur="infoFournissseur" @updatePage="numPage"></tab3>
                                </vs-tab>
                            </vs-tabs>
                            <div class="flex mb-4 vx-col md:w-full">
                                <div class="vx-col md:w-1/6"></div>
                                <div class="vx-col md:w-1/3  w-full bg-grid-color-secondary h-12 px-2">
                                    <div class="w-full mt-1 vx-row">
                                        <vs-button :color="colorx" icon="keyboard_backspace" @click="tabPrec" :disabled="activeTabNum==0">précedant</vs-button>

                                    </div>
                                </div>
                                <div class="vx-col md:w-1/3   w-full bg-grid-color-secondary px-2">
                                    <div class="w-full mt-1">

                                        <vs-button :color="colorx" icon="arrow_right_alt" @click="tabSuivant" :disabled="activeTabNum==3">suivant</vs-button>

                                    </div>
                                </div>
                                <div class="vx-col md:w-1/3   w-full bg-grid-color-secondary px-2">
                                    <div class="w-full mt-1">

                                        <vs-button class="float-right" @click.stop="saveDemande()" :disabled="activeTabNum!=3 || isSaveDisabled">enregistrer</vs-button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</div>
</template>

<script>
import Info from './Info.vue'
import Tab1 from './Tab1.vue'
import Tab2 from './Tab2.vue'
import Tab3 from './Tab3'
import indexfour from "@/http/requests/fournisseur/index.js";

export default {
    components: {
        Info,
        Tab2,
        Tab3,
        Tab1
    },
    data() {
        return {

            colorx: '#5252e8',
            activeTabNum: 0,
            infoFournissseur: {

            },
            pieceJointe1: null,
        }

    },
    watch: {

    },
    computed: {
        isSaveDisabled: function () {
            return this.infoFournissseur.raisonSociale == null || this.infoFournissseur.matriculeFisc == null || this.infoFournissseur.email == null || this.infoFournissseur.typeAchat == null;

        }
    },
    methods: {
        numPage: function (params) {
            this.activeTabNum = params
        },

        tabSuivant: function () {

            this.activeTabNum += 1;

        },
        tabPrec: function () {

            this.activeTabNum -= 1;
        },
        saveDemande() {
            console.log(this.infoFournissseur)
            this.infoFournissseur.typeAchat = this.infoFournissseur.typeAchat.label
            indexfour.saveDemandeCompteFournisseur(this.infoFournissseur).then(response => {
                console.log(response);
            }).catch(error => {
                console.log(error.data)
            });
        }
    }
}
</script>

<style lang="scss">
.register-tabs-container {
    min-height: 517px;

    .con-tab {
        padding-bottom: 23px;
    }
}
</style>
